var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"toggle-icon icon",class:{ 
    'icon-stihl-dropdown-up-arrow': _vm.isModalOpen, 
    'icon-stihl-dropdown-down-arrow': !_vm.isModalOpen
  },on:{"click":_vm.toggleModal}})}
var staticRenderFns = []

export { render, staticRenderFns }